<app-item [entity]="entity"
          (updateButtonClicked)="edit()"
          deleteWarningMessage="Cette étiquette sera enlevée de tous les éléments qui lui sont liés"
          [deleteService]="deleteService">
    <app-summary>
        <ng-container title>
            <div style="height: 20px; width: 20px; display: inline-block"
                 [style.background-color]="entity.color"
                 class="m-x-4 rounded-circle"></div>
            <strong>{{entity.name}}</strong>
        </ng-container>
    </app-summary>
</app-item>
